// 字符串格式化 回车转/r
var formatEnter = function formatEnter(str) {
  return str.replace(/↵/g, '/r');
};

// 字符串格式化 回车转</br>
var formatEnter2 = function formatEnter2(str) {
  return str.replace(/\n/g, '<br/>');
};

// 字符串格式化 回车转<br>
var formatEnterBr = function formatEnterBr(str) {
  return str.replace(/\n/g, '<br>');
};

// 字符串格式化 <br>转空格
var formatEnterNbsp = function formatEnterNbsp(str) {
  return str.replace(/<br>/g, ' ');
};

var iconNameFormate = function iconNameFormate(iconName) {
  var arr = iconName.split('/');
  return arr[arr.length - 1];
};
// 复制文本 data:需要被复制的文本
var copyStr = function copyStr(data) {
  var url = data;
  var oInput = document.createElement('input');
  oInput.value = url;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象;
  document.execCommand("Copy"); // 执行浏览器复制命令
  this.$message({
    message: '复制成功',
    type: 'success'
  });
  oInput.remove();
};

export default {
  formatEnter: formatEnter,
  formatEnter2: formatEnter2,
  iconNameFormate: iconNameFormate,
  copyStr: copyStr,
  formatEnterBr: formatEnterBr,
  formatEnterNbsp: formatEnterNbsp
};


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/utils/string.js
// module id = APvK
// module chunks = 115